import { useState } from 'react';
import { Loader2, Play } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { recurringCostMatchingAPI } from '../../lib/api';
import { toast } from 'sonner';
import { getErrorMessage } from '../../lib/errors';

// Manual trigger for the daily recurring-cost matching job (mirrors the
// scheduled server.py cron job -- see services/recurring_cost_matcher.py).
// Preview/Apply for a specific match set lives on the Reconciliation page;
// this is the same "run everything now" action the scheduler performs.
export function RecurringCostMatchingRunNowPanel() {
  const [running, setRunning] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const runNow = async () => {
    setRunning(true);
    try {
      await recurringCostMatchingAPI.runNow();
      const { data: census } = await recurringCostMatchingAPI.getCensus();
      setLastResult(census);
      toast.success('Recurring cost matching run complete');
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setRunning(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-base">Recurring Cost Matching</CardTitle>
            <CardDescription>
              Generate this month's expected instances and apply deterministic matches now (same job runs daily at 06:30 UTC)
            </CardDescription>
          </div>
          <Button size="sm" onClick={runNow} disabled={running}>
            {running ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Play className="h-4 w-4 mr-1" />}
            Run now
          </Button>
        </div>
      </CardHeader>
      {lastResult && (
        <CardContent>
          <p className="text-sm text-muted-foreground">
            {lastResult.generation?.instances_created ?? 0} instance(s) created ·{' '}
            {lastResult.bucket_counts?.matched ?? 0} matched ·{' '}
            {lastResult.bucket_counts?.expected_unmatched ?? 0} still expected-unmatched
          </p>
        </CardContent>
      )}
    </Card>
  );
}
